import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';
import {Racer} from '../../../../racer-tab/Racer';

@Injectable({
  providedIn: 'root'
})
export class RacerService extends BaseDatabaseService{

  racer: Racer;

  private collectionName = 'racer';

  constructor() {
    super();
  }

  getRacers() {
    return this.db.collection(this.collectionName).get();
  }

  getOneRacer(key: string) {
    return this.db.collection(this.collectionName).doc(key).get();
  }

  createRacer(racer) {
    const obj = racer;
    return this.db.collection(this.collectionName).doc().set(obj);
  }

  update(racer){
    let id;
    let obj;

    if(racer.id !== undefined){
      id = racer.id
      obj = racer;
      delete obj.id;
    } else {
      id = racer.key;
      obj = racer;
    }
    let ref = this.db.collection(this.collectionName).doc(id);
    return ref.update(obj);
  }

  delete(id) {
    return this.db.collection(this.collectionName).doc(id).delete();
  }
}
